// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import feathers from '@feathersjs/client'
import feathersAuth from '@feathersjs/authentication-client'
import feathersRest from '@feathersjs/rest-client'
import axios from 'axios'

export const feathersStorage: Storage = {
    getItem: (key) => (typeof window !== 'undefined' ? localStorage.getItem(key) : ''),
    removeItem: (key) => localStorage.removeItem(key),
    setItem: (key, value) => localStorage.setItem(key, value),
    clear: () => localStorage.clear(),
    key: (index) => localStorage.key(index),
    length: typeof localStorage !== 'undefined' ? localStorage.length : 0,
}

const PRODUCTION_API_URL = 'https://api.sushi2go.com.co'
const LOCAL_API_URL = 'http://localhost:3030'

/**
 * En el browser `process` no existe. El define de Vite reemplazaba
 * process.env.REACT_APP_API_URL pero dejaba el check `typeof process`,
 * y en producción caía a localhost (mixed content / login roto).
 */
function resolveApiUrl(): string {
  const fromVite = import.meta.env.VITE_API_URL
  if (fromVite && typeof fromVite === 'string' && fromVite.trim()) {
    return fromVite.replace(/\/$/, '')
  }

  if (import.meta.env.PROD) {
    return PRODUCTION_API_URL
  }

  return LOCAL_API_URL
}

export const API_URL = resolveApiUrl()

const app = feathers()
const restClient = feathersRest(API_URL)

app.configure(restClient.axios(axios))

app.configure(
    feathersAuth({
        path: '/authentication',
        storageKey:'jwt',
        storage: feathersStorage,
    }),
)

export const Api = axios.create({
    baseURL: API_URL,
    headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    }
});

export const service = (service: string) => {
    return {
        patch: (id: string, params: any) => Api.put(service + "/" + id, params),
        get: (id: string) => Api.get(service + "/" + id),
        find: (query: any) => Api.get(service, {
            query
        }),
        remove: (id: string) => Api.delete(service + "/" + id),
        create: (params: any) => Api.post(service, params),
    }
}

export const getService = (service: string) => app.service(service);

export default app
